export const ActionKeys = {
  SHOW_MENU: "SHOW_MENU",
  HIDE_MENU: "HIDE_MENU"
};
